<template>
  <div class="content">
    <product-form-modal :product="dataall"></product-form-modal>
    <unit></unit>
    <model></model>
    <brand></brand>
    <colour></colour>
        <extraunit></extraunit>
    <country></country>
    <b-modal id="modal-close" centered>
      <h4>
        {{$t('Sizda saqlanmagan malumotlar mavjud. Saqlansinmi?')}}
      </h4>

      <template #modal-footer="{ ok, cancel, hide }">
        <button type="button" class="btn btn-success" style="margin-bottom: 16px;"
          @click="$root.$refs.product.Savedokument()">{{$t('Да')}}</button>
        <button type="button" class="btn btn-danger" @click='Home()'>{{$t('Нет')}}</button>
        <button type="button" class="btn btn-primary" @click="cancel()">{{$t('Отмена')}}</button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { ProductFormModal,Extraunit, Unit, Model, Brand, Colour, Country } from "@/pages";
export default {
  components: { ProductFormModal,Extraunit, Unit, Model, Brand, Colour, Country },
  data() {
    return {
      dataall: []
    };
  },
  watch: {
    dataall: {
      deep: true,
      handler(val, oldVal) {
        this.$store.state.saved += 1;
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.$store.state.saved < 3) {
      this.$store.state.saved = null;
      next();
    } else {
      this.$bvModal.show("modal-close");
    }
  },
  methods:{
    Home() {
        this.$store.state.saved = null;
        this.$bvModal.hide('modal-close');
        this.$router.push({ name: "Товар модал" });
      }
  },
  created: function() {
    let self = this;
    axios
      .get("api/v1/product/id/" + self.$route.params.id)
      .then(function(response) {
        self.dataall = response.data;
        setTimeout(() => {
          if (self.dataall.shtrix_table.length == 0) {
              self.$root.$refs.product.Addshtrix();
          }
        }, 1000);
      });
  }
};
</script>
